import {httpRequest} from '../config/axios';
const logOut = async (body) => {
  return await httpRequest.post(`/auth/logout`, body);
};

const getProfileApi = async ({token}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(token && {'user-token': token}),
  };
  return await httpRequest.get('/auth/user-profile', {
    headers,
  });
};

export {logOut, getProfileApi};
